/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FlexCol, FlexRow, RequiredValidation, TextField } from 'sarsaparilla';

import { databindings } from '../../constants/registration';
import { DNR_NUMBER_PROP_PATH } from '../../constants';
import { HuntingLotteryApplicationProps } from '../../props';

const propTypes = {
    displayValidationError: PropTypes.bool.isRequired,
    pActions: PropTypes.shape({
        updatePendingReservation: PropTypes.func.isRequired,
        formValidationChange: PropTypes.func.isRequired,
    }).isRequired,
    validation: PropTypes.shape({}).isRequired,
    reservation: HuntingLotteryApplicationProps,
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    mdSize: PropTypes.number,
};

const DNRNumberInput = React.memo(
    ({
        reservation,
        pActions,
        validation,
        displayValidationError,
        mdSize = 5,
        disabled = false,
        isRequired = false,
    }) => {
        const dnrNumberPropPath = databindings[DNR_NUMBER_PROP_PATH];

        const onFormValidate = useCallback(
            (isInvalid, error) =>
                pActions.formValidationChange(
                    `${reservation.id}_${dnrNumberPropPath}`,
                    isInvalid ? error : null
                ),
            [reservation.id]
        );
        const dnrNumber = get(reservation, dnrNumberPropPath, '');
        const dnrNumberIsInvalid =
            !!get(validation, `${reservation.id}_${dnrNumberPropPath}`) &&
            displayValidationError;
        return (
            <FlexRow key="dnrNumber-input">
                <FlexCol xs={6} md={mdSize}>
                    <TextField
                        label="State Hunting License Number"
                        id="dnrNumber-input"
                        value={dnrNumber}
                        isInvalid={dnrNumberIsInvalid}
                        onChange={(e) =>
                            pActions.updatePendingReservation(
                                reservation.id,
                                dnrNumberPropPath,
                                e.target.value
                            )
                        }
                        isDisabled={disabled}
                        isRequired={isRequired}
                    />
                    {isRequired && (
                        <RequiredValidation
                            value={dnrNumber}
                            displayInSummary
                            onValidated={onFormValidate}
                            controlLabel="State Hunting License Number"
                        />
                    )}
                </FlexCol>
            </FlexRow>
        );
    }
);

export default DNRNumberInput;

DNRNumberInput.propTypes = propTypes;
